import React, { useState, useEffect } from 'react';
import './Loading.css';

// Loading süresi ayarları
const LOADING_CONFIG = {
  totalDuration: 2000, // Toplam loading süresi (ms)
  progressInterval: 100, // Progress güncelleme aralığı (ms)
  progressIncrement: 15, // Her interval'de artan progress miktarı (random ile çarpılacak)
  textShowDelay: 1000, // Metnin gösterilme gecikmesi (ms)
  completionDelay: 500 // Tamamlandıktan sonra callback'in çalışma gecikmesi (ms)
};

const Loading = ({ onLoadingComplete }) => {
  const [loadingProgress, setLoadingProgress] = useState(0);
  const [showText, setShowText] = useState(false);

  useEffect(() => {
    // Progress increment hesaplama (totalDuration'a göre otomatik)
    const maxIncrement = (100 / (LOADING_CONFIG.totalDuration / LOADING_CONFIG.progressInterval)) * 1.5;
    const progressIncrement = Math.min(maxIncrement, LOADING_CONFIG.progressIncrement);

    // Loading progress simulation
    const progressInterval = setInterval(() => {
      setLoadingProgress(prev => {
        if (prev >= 100) {
          clearInterval(progressInterval);
          setTimeout(() => {
            onLoadingComplete();
          }, LOADING_CONFIG.completionDelay);
          return 100;
        }
        return prev + Math.random() * progressIncrement;
      });
    }, LOADING_CONFIG.progressInterval);

    // Show text after specified delay
    setTimeout(() => {
      setShowText(true);
    }, LOADING_CONFIG.textShowDelay);

    return () => clearInterval(progressInterval);
  }, [onLoadingComplete]);

  return (
    <div className="ls-loader">
      <div className="logo-carrier">
        <img 
          src="/lysep_logo.svg" 
          alt="LYSEP Logo" 
          className="loading-logo first"
        />
        <img 
          src="/lysep_logo.svg" 
          alt="LYSEP Logo" 
          className="loading-logo second"
        />
        <h1 className={`loading-text ${showText ? 'show' : ''}`}>
          <span className="lysep-text">LYSEP</span>
          {/*<span className="corp-text">CORPORATION</span>*/}
        </h1>
      </div>
    </div>
  );
};

export default Loading;
